import { observer } from "mobx-react";
import pluralize from "pluralize";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import Popup from "reactjs-popup";

import Button from "@/components/form/Button";
import DateInput from "@/components/form/react-hook-form/DateInput";
import SelectInput from "@/components/form/react-hook-form/SelectInput";
import TextAreaInput from "@/components/form/react-hook-form/TextAreaInput";
import TextInput from "@/components/form/react-hook-form/TextInput";
import Loading from "@/components/Loading";
import { useMainStore } from "@/contexts/Store";
import { useLoading } from "@/hooks/useLoading";
import logo from "@/images/logo.svg";
import thumbsUpIcon from "@/images/table-image/icon/thumbs-up-blue.svg";

const IGNORE_FIELDS = [
  "Created By",
  "Created At",
  "Last Updated By",
  "Last Updated At",
  "Last Closed By",
  "Last Closed At",
  "Last Reopened At",
  "ID",
];

function SubmitConflict() {
  const mainStore = useMainStore();
  const {
    formState: { errors },
    handleSubmit,
    register,
  } = useForm();
  const moduleAccessTokensStore = mainStore.moduleAccessTokens;
  const [showPopUp, setShowPopUp] = useState(false);
  const [requestErrors, setRequestErrors] = useState(null);
  const [moduleName, setModuleName] = useState("Conflicts of Interest");
  const COLUMN_INFO = {
    "com.askthemis.types.v1.text": {
      component: TextInput,
    },
    "com.askthemis.types.v1.link": {
      component: TextInput,
    },
    "com.askthemis.types.v1.long_text": {
      component: TextAreaInput,
    },
    "com.askthemis.types.v1.date": {
      component: DateInput,
    },
    "com.askthemis.types.v1.option": {
      component: SelectInput,
    },
  };
  const workspaceId = moduleAccessTokensStore.workspaceID;
  const { token } = useParams<{ token: string }>();
  const fields = mainStore.fields.list;
  const ignoreFields = [
    "Approvers",
    "Documents",
    "Status",
    "Submission Date",
    "Additional Info",
    "Compliance Notes",
    "Public Compliance Notes",
  ];

  const ignoreFieldsForSubmitForm = ignoreFields.concat(IGNORE_FIELDS);
  const closeModal = () => setShowPopUp(false);

  // Hooks
  const loading = useLoading(fields);

  useEffect(() => {
    (async () => {
      const { module_name } = await moduleAccessTokensStore.fetch_fields(token);
      setModuleName(module_name);
    })();
  }, []);

  // @ts-expect-error TS(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
  function handleFailure(response) {
    window.console.log(response);
    window.scrollTo(0, 0);
    setRequestErrors(response);
    setShowPopUp(true);
  }

  function handleSuccess() {
    setRequestErrors(null);
    window.scrollTo(0, 0);
    setShowPopUp(true);

    // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
    document.getElementById("conflicts-of-interest-form").reset();
  }
  // @ts-expect-error TS(7006) FIXME: Parameter 'data' implicitly has an 'any' type.
  function onSubmit(data) {
    if (workspaceId) {
      mainStore.conflicts.create(workspaceId, data).then((response) => {
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        if (response.status == "201") {
          handleSuccess();
        } else {
          handleFailure(response);
        }
      });
    }
  }

  if (loading) {
    return <Loading loadingLayout="small-table" showTableHeader={false} />;
  }
  return (
    <div className="submit-conflict">
      <img src={logo} alt="logo" className="logo" />
      <div className="submit-conflict-container">
        <h2> Submit Your Potential {pluralize.singular(moduleName)} Form </h2>
        <form id="conflicts-of-interest-form" onSubmit={handleSubmit(onSubmit)}>
          {fields.map((field) => {
            const fieldName = field.name;
            const fieldType = field.data_type;
            const fieldDisplayName = field.display_name;
            // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            const dataType = COLUMN_INFO[fieldType];
            const options = mainStore.fieldOptions.optionsForField(fieldName);
            if (!dataType) {
              return null;
            }

            const { component: Component } = dataType;

            if (ignoreFieldsForSubmitForm.includes(fieldDisplayName)) {
              return null;
            }

            const fieldError = errors[fieldDisplayName]?.message;

            return (
              <div key={fieldName} data-testid={fieldDisplayName}>
                <h4>{fieldDisplayName}</h4>
                <Component
                  name={fieldDisplayName}
                  dataTestId={fieldDisplayName}
                  register={register}
                  options={options}
                />
                <p className="error-input">
                  {fieldError ? `${fieldError}` : <span>&nbsp;</span>}
                </p>
              </div>
            );
          })}
          <Button title="Submit" />
        </form>

        <Popup
          open={showPopUp}
          closeOnDocumentClick
          contentStyle={{
            margin: "0 auto",
            top: 40,
            width: "390px",
            height: "95px",
          }}
          onClose={closeModal}
        >
          <>
            {requestErrors && (
              <div className="modal submit-conflict-success">
                Sorry, there was a problem. Please try again or contact
                support@themis.com.
              </div>
            )}
            {!requestErrors && (
              <div className="modal submit-conflict-success">
                <img src={thumbsUpIcon} alt="thumbs up icon" />
                Success! Thank you for submitting your conflict of interest
                form. If you want to add another, please submit this form again.
              </div>
            )}
          </>
        </Popup>
      </div>
    </div>
  );
}

export default observer(SubmitConflict);
